
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandScreenHeaderFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandScreenHeader"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brandHeroImageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brandLogoImageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brandDesc"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"fragment BrandScreenHeaderFields on BrandScreenHeader {\n  id\n  brandHeroImageUrl\n  brandLogoImageUrl\n  brandDesc\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
